export class SimplifiedTerm {
  public Guid: string;
  public Name: string;
  public InternalName: string;
  public Url: string;
  public FriendlyUrl: string;
  public TermCount = 0;
  public LastModified: Date;
  public Terms: Array<SimplifiedTerm> = new Array<SimplifiedTerm>();
  public Labels: Array<TermLabel>;
  public LocalCustomProperties: { [key: string]: string; } = {};
  public IsRoot: boolean;
  public IsAvailableForTagging: boolean;
  public IsDeprecated: boolean;
  public ParentTermGuid?: string;

  public Selected: boolean;
  public DisableSelection: boolean;
  public UseRadioButtons: boolean;  // Use "single select" on child terms

  constructor(opt?: Partial<SimplifiedTerm>) {
    Object.assign(this, opt);
    this.Terms = this.Terms.map(t => new SimplifiedTerm(t));
    this.TermCount = this.Terms.length;
  }
}

export interface TermLabel {
  Name: string;
  Language: number;
}
